<div *ngIf="service !== null" class="input-file">
    <label class="input_label mt-2">{{ service.modelClass.langBase + label | translatePipe }}</label>
    <input type="file" [name]="name" [multiple]="multiple" (change)="onFilesAdded($event)" [required]="required" [accept]="'image/*'" ch>
</div>
